import { makeStyles } from '@material-ui/core/styles'

//import HARDCODE from '../../business-const/HardCode/HardCode'

export const typographyStyles = makeStyles(({ palette, ...theme }) => ({
    '@global': {
        '.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6': {
            margin: '0 0 0.5rem',
            lineHeight: '1.1',
            color: 'inherit',
        },
        '.h1, h1': { fontSize: '2rem' },//2rem
        '.h2, h2': { fontSize: '1.75rem' },//1.75rem
        '.h3, h3': { fontSize: '1.5rem' },//1.5rem
        '.h4, h4': { fontSize: '1.25rem' },//1.25rem
        '.h5, h5': { fontSize: '1rem' },//1rem
        '.h6, h6': { fontSize: '0.875rem' },//0.875rem
        a: { textDecoration: 'none', color: 'inherit' },
        '.caption': { font: 'var(--font-caption)' },
        '.subtitle-1': { font: 'var(--font-subtitle-1)' },
        '.subtitle-2': { font: 'var(--font-subtitle-2)' },
        '.heading': { font: 'var(--font-heading)' },
        '.title': { font: 'var(--font-title)' },
        '.display-1': { font: 'var(--font-display-1)' },
        '.display-2': { font: 'var(--font-display-2)' },
        '.display-3': { font: 'var(--font-display-3)' },
        '.display-4': { font: 'var(--font-display-4)' },
        '.capitalize': { textTransform: 'capitalize !important' },
        '.none': { textTransform: 'none !important' },
        '.uppercase': { textTransform: 'uppercase !important' },
        '.lowercase': { textTransform: 'lowercase !important' },
        //'.font-family-poppins': { fontFamily: AuthService.obterFontFamily(false)}, // mudança da fonte
        '.font-normal': { fontWeight: 'normal !important' },
        '.font-light': { fontWeight: '300 !important' },
        '.font-light-medium': { fontWeight: '400 !important' },
        '.font-medium': { fontWeight: '500 !important' },
        '.font-semibold': { fontWeight: '600 !important' },
        '.font-bold': { fontWeight: '700 !important' },
        '.font-italic': { fontStyle: 'italic' },
        '.font-underline': { textDecoration: 'underline' },
        '.text-6': { fontSize: '6px !important' },//incluido
        '.text-7': { fontSize: '7px !important' },//incluido
        '.text-8': { fontSize: '8px !important' },//incluido
        '.text-9': { fontSize: '9px !important' },//incluido
        '.text-10': { fontSize: '10px !important' },//incluido
        '.text-11': { fontSize: '11px !important' },//11px
        '.text-12': { fontSize: '12px !important' },//12px
        '.text-13': { fontSize: '13px !important' },//13px
        '.text-14': { fontSize: '14px !important' },//14px
        '.text-15': { fontSize: '15px !important' },//15px
        '.text-16': { fontSize: '16px !important' },//16px
        '.text-17': { fontSize: '17px !important' },//incluido
        '.text-18': { fontSize: '18px !important' },//18px
        '.text-19': { fontSize: '19px !important' },//incluido
        '.text-20': { fontSize: '20px !important' },//incluido
        '.text-21': { fontSize: '21px !important' },//incluido
        '.text-22': { fontSize: '22px !important' },//22px
        '.text-24': { fontSize: '24px !important' },//24px
        '.text-26': { fontSize: '26px !important' },//incluido
        '.text-28': { fontSize: '28px !important' },//28px
        '.text-30': { fontSize: '30px !important' },//30px
        '.text-32': { fontSize: '32px !important' },//32px
        '.text-36': { fontSize: '36px !important' },//36px
        '.text-40': { fontSize: '40px !important' },//40px
        '.text-44': { fontSize: '44px !important' },//44px
        '.text-48': { fontSize: '48px !important' },//48px
        '.text-54': { fontSize: '54px !important' },//54px
        '.text-58': { fontSize: '58px !important' },//58px
        '.text-62': { fontSize: '62px !important' },//62px
        '.text-72': { fontSize: '72px !important' },//72px
        '.text-small': { fontSize: '0.8125rem !important' },//0.8125rem
        '.text-helperText': { fontSize: '0.5125rem !important' },//incluido  // se for alterado, revisar Sytle.js FONTSIZE HelperText
        '.whitespace-pre-wrap': {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
        },
        '.whitespace-pre': { whiteSpace: 'pre' },
        '.whitespace-no-wrap': { whiteSpace: 'nowrap' },
        '.line-height-1': { lineHeight: 1 },
        '.ellipsis': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
        },
    },
}))